import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FinderScreen, none } from './finderScreen';

interface FinderState {
  viewModel: FinderScreen.ViewModel;
}

const initialState: FinderState = {
  viewModel: none(),
};

export const finderSlice = createSlice({
  name: 'finder',
  initialState,
  reducers: {
    setViewModel: (state, action: PayloadAction<FinderScreen.ViewModel>) => {
      state.viewModel = action.payload;
    },
  },
});

export const { setViewModel } = finderSlice.actions;

export default finderSlice.reducer;
